import script from "./MergeGlobalGroupsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MergeGlobalGroupsModal.vue?vue&type=script&setup=true&lang=js"

import "./MergeGlobalGroupsModal.vue?vue&type=style&index=0&id=b45298de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b45298de"]])

export default __exports__